<template>
  <div class="messages">
    <div v-for="item of messagesArray" :key="messagesArray.indexOf(item)">
      <v-alert v-if="showNotification" dense border="left" :type="item.type" width="30rem">
        {{item.message}}
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: [ ],
  data: () => ({
    
  }),
  computed: {
    ...mapGetters('notificationModule', ['typeAlert', 'messageAlert']),
    ...mapGetters('notificationModule',  { messagesArray : 'getMessagesArray'}),
    showNotification() {
      return !!this.messageAlert;
    }
  },
};
</script>


<style>
.messages {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
</style>
